import { render } from "./StepBarThatContainsStatus.vue?vue&type=template&id=205fa717"
import script from "./StepBarThatContainsStatus.vue?vue&type=script&lang=ts"
export * from "./StepBarThatContainsStatus.vue?vue&type=script&lang=ts"
script.render = render

export default script